export enum AdministrationTab {
  AFFILIATIONS = 0,
  COMPANIES = 1,
  PROSPECT_SEARCH = 2,
  USERS = 3,
  LLM_COSTS = 4,
}
